import React, { useState, useEffect } from 'react';
import { getFurgones, createFurgon, updateFurgon, deleteFurgon } from '../services/api';

function Furgones() {
  const [furgones, setFurgones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [editando, setEditando] = useState(null);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ numero: '', fechaSalida: '', estado: 'Recibido en Florida' });

  const estados = ['Recibido en Florida', 'Cargado en Furgón', 'En Tránsito', 'Llegó a República Dominicana', 'Entregado'];

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    getFurgones().then(res => { setFurgones(res.data); setLoading(false); }).catch(() => setLoading(false));
  };

  const abrirNuevo = () => {
    setEditando(null);
    setForm({ numero: '', fechaSalida: '', estado: 'Recibido en Florida' });
    setError(''); setModal(true);
  };

  const abrirEditar = (f) => {
    setEditando(f);
    setForm({ numero: f.numero, fechaSalida: f.fechaSalida?.split('T')[0] || '', estado: f.estado });
    setError(''); setModal(true);
  };

  const guardar = async () => {
    if (!form.numero) { setError('El número de furgón es requerido'); return; }
    try {
      if (editando) await updateFurgon(editando.id, form);
      else await createFurgon(form);
      setModal(false); cargar();
    } catch { setError('Error al guardar.'); }
  };

  const eliminar = async (f) => {
    if (!window.confirm(`¿Eliminar el furgón #${f.numero}? Esta acción no se puede deshacer.`)) return;
    try {
      await deleteFurgon(f.id);
      cargar();
    } catch (err) {
      alert(err?.response?.data?.message || 'Error al eliminar el furgón.');
    }
  };

  const badgeEstado = (estado) => {
    const map = {
      'Recibido en Florida': { bg: '#f1f5f9', color: '#64748b' },
      'Cargado en Furgón': { bg: '#dbeafe', color: '#1d4ed8' },
      'En Tránsito': { bg: '#fef3c7', color: '#d97706' },
      'Llegó a República Dominicana': { bg: '#ede9fe', color: '#7c3aed' },
      'Entregado': { bg: '#dcfce7', color: '#16a34a' },
    };
    const s = map[estado] || { bg: '#f1f5f9', color: '#64748b' };
    return { background: s.bg, color: s.color, padding: '3px 10px', borderRadius: 100, fontSize: 11, fontWeight: 600 };
  };

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#64748b' }}>Cargando...</div>;

  return (
    <div>
      <div style={{ background: 'white', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
        <div style={{ padding: '18px 22px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>Furgones ({furgones.length})</h3>
          <button onClick={abrirNuevo} style={{ padding: '8px 16px', background: '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>+ Nuevo Furgón</button>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['Furgón No.', 'Fecha Salida', 'Estado', 'Acciones'].map(h => (
                  <th key={h} style={{ padding: '11px 16px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {furgones.length === 0 ? (
                <tr><td colSpan={4} style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>No hay furgones</td></tr>
              ) : furgones.map(f => (
                <tr key={f.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '13px 16px', fontWeight: 700, fontSize: 15 }}>#{f.numero}</td>
                  <td style={{ padding: '13px 16px', fontSize: 14 }}>{f.fechaSalida ? new Date(f.fechaSalida).toLocaleDateString('es-DO') : '—'}</td>
                  <td style={{ padding: '13px 16px' }}><span style={badgeEstado(f.estado)}>{f.estado}</span></td>
                  <td style={{ padding: '13px 16px' }}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button onClick={() => abrirEditar(f)} style={{ padding: '6px 12px', background: '#f1f5f9', border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>✏️ Editar</button>
                      <button onClick={() => eliminar(f)} style={{ padding: '6px 12px', background: '#fee2e2', border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>🗑️ Eliminar</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 440, boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#0d2461' }}>{editando ? 'Editar Furgón' : 'Nuevo Furgón'}</h2>
              <button onClick={() => setModal(false)} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#94a3b8' }}>×</button>
            </div>
            <div style={{ padding: 24 }}>
              {error && <div style={{ background: '#fee2e2', color: '#cc0000', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>⚠️ {error}</div>}
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase' }}>Furgón No.</label>
                <input value={form.numero} onChange={e => setForm({ ...form, numero: e.target.value })} placeholder="Ej: 147"
                  style={{ width: '100%', marginTop: 5, padding: '9px 12px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase' }}>Fecha Salida</label>
                <input type="date" value={form.fechaSalida} onChange={e => setForm({ ...form, fechaSalida: e.target.value })}
                  style={{ width: '100%', marginTop: 5, padding: '9px 12px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase' }}>Estado</label>
                <select value={form.estado} onChange={e => setForm({ ...form, estado: e.target.value })}
                  style={{ width: '100%', marginTop: 5, padding: '9px 12px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, fontFamily: 'inherit', outline: 'none' }}>
                  {estados.map(e => <option key={e}>{e}</option>)}
                </select>
              </div>
            </div>
            <div style={{ padding: '16px 24px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
              <button onClick={() => setModal(false)} style={{ padding: '9px 18px', background: 'white', color: '#0d2461', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Cancelar</button>
              <button onClick={guardar} style={{ padding: '9px 18px', background: '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>💾 Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Furgones;